import Vue from 'vue';
import App from './App';
import '@/icons';
import * as utils from '@/utils';
import './share';

Vue.prototype.$utils = utils;
import '@/styles/index.less';

let data = utils.getInputValue('platform', {});
let isPreview = utils.getInputValue('is_preview', false);

Vue.prototype.$platform = {
  isMember: data.isMember,
  registerHref: data.registerHref,
  categoryMode: data.categoryMode
};

Vue.prototype.$pub = new Vue();
Vue.prototype.$IS_PREVIEW = isPreview;
Vue.prototype.$clientWidth = document.documentElement.clientWidth;

new Vue({
  render: h => h(App),
  components: {App}
}).$mount('#root');
